import script from "./Course.vue?vue&type=script&lang=ts&setup=true"
export * from "./Course.vue?vue&type=script&lang=ts&setup=true"

import "./Course.vue?vue&type=style&index=0&id=dfc729d0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfc729d0"]])

export default __exports__